<template>
  <el-form class="search-form" :model="searchForm" inline label-width="60px">
    <el-form-item :label="$t('common.singerName')">
      <el-input v-model="searchForm.singerName" clearable :placeholder="$t('common.singerNamePlaceholder')" @keypress.native.enter="handleSearch"></el-input>
    </el-form-item>
    <el-form-item :label="$t('singer.type')">
      <el-select v-model="searchForm.type" :placeholder="$t('singer.typePlaceholder')" clearable @change="handleSearch">
        <el-option
          v-for="(name, key) in actorTypeMap"
          :key="key"
          :label="$t(`singer.singerTypeMap[${key}]`)"
          :value="+key"
        ></el-option>
      </el-select>
    </el-form-item>
    <div class="right">
      <slot />
    </div>
  </el-form>
</template>

<script>
import {
  actorTypeMap,
} from '../mixin.js'

export default {
  name: 'SearchForm',
  data() {
    return {
      actorTypeMap,
      searchForm: {
        singerName: '',
        type: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      searching: false,
      showAdd: false
    }
  },

  methods: {
    handleSearch() {
      this.$emit('search')
    }
  }
}
</script>

<style lang="scss" scoped>
.search-form .el-form-item  {
  margin-bottom: 8px !important;
}
</style>
